/**
 * Created by Angelika on 30.08.2017.
 */
import * as actionTypes from '../constants/actionTypes';
import {InitObject} from '../api/objects';
import StalkerApiManager from '../api/StalkerApiLoaderManager';
import {clearChannelCards} from './channelCards';
import {resetGenreFilter} from './genres';
import {clearUserData} from './userData';
import {cancelRegistration} from './registration';

let api = StalkerApiManager.getInstance();
let loader = api.getLoader();

export function login(username, password) {
    return dispatch => {
        dispatch({type: actionTypes.LOGIN_REQUEST});
        let stalkerObject = new InitObject();
        stalkerObject.setMac(api.getMac());
        stalkerObject.setLogin(username);
        stalkerObject.setPassword(password);

        return loader.login(stalkerObject).then(
            data => {
                loader.startSendUserActivity();
                dispatch({type: actionTypes.LOGIN_SUCCESS});
            },
            error_description => dispatch({type: actionTypes.LOGIN_FAILED, error: error_description})
        );
    }
}

export function logout() {
    return dispatch => {
        dispatch({type: actionTypes.LOGOUT_REQUEST});
        return loader.logout().then(
            () => {
                loader.stopSendUserActivity();
                dispatch({type: actionTypes.LOGOUT_SUCCESS});
                dispatch(clearChannelCards());
                dispatch(resetGenreFilter());
                dispatch(clearUserData());
                dispatch(cancelRegistration());
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/actions/login.js